import { useState, useEffect, useRef } from "react"
import { Flex, Input, Modal, Form, Dropdown, List, Button } from "antd"
import { useTranslation } from "react-i18next"
import { getStrayCards, connectCard } from "../../../../api/Cards"
import { useUser } from "../../../../contexts/UserContext"
import "./NewCardModal.css"

const CardManageModal = ({ onClose, selectedCard }) => {

    const handleCancel = () => onClose();
    const { t } = useTranslation()
    const { user, getToken } = useUser()

    const disconnectCard = () => {
        async function disconnectUserFromCard() {
            const data = await connectCard({ Token: user.token, CardID: selectedCard, UserID: -1 })
            if (typeof data == "number") {
                return;
            }
            handleCancel();
        }
        disconnectUserFromCard();
    }

    return (
        <Modal footer={null} width={'635px'} minHeight={'300px'} onCancel={handleCancel} cancelText={t("page.acceditormodal.close")} open>
            <Flex style={{ justifyContent: "center", flexDirection: "row", flexWrap: "wrap" }}>
                <Button onClick={disconnectCard}>{t('page.cardmanage.disconnect')}</Button>
            </Flex>
        </Modal>
    )
}

export default CardManageModal
